export const SEARCH_FILTERS = [
  { value: 'order_id', label: 'Order ID' },
  { value: 'email', label: 'Customer Email' },
  { value: 'phone', label: 'Customer Phone' },
  { value: 'term', label: 'Transaction ID' },
  { value: 'merchant_reference', label: 'Merchant Reference' },
  { value: 'external_id', label: 'PSP Reference' },
];

export const STATUS_AUTHORIZED = 'authorized';
export const STATUS_REFUSED = 'refused';
export const STATUS_SETTLED = 'settled';
export const STATUS_CANCELLED = 'cancelled';
export const STATUS_REFUNDED = 'refunded';
export const STATUS_PARTIALLY_REFUNDED = 'partially_refunded';
export const STATUS_FAILED = 'failed';
export const STATUS_EXPIRED = 'expired';
export const STATUS_PENDING = 'pending';

export const STATUS_SUCCESS = 'success';

export const STATUS_FILTERS = [
  { label: 'Authorized', value: STATUS_AUTHORIZED },
  { label: 'Refused', value: STATUS_REFUSED },
  { label: 'Settled', value: STATUS_SETTLED },
  { label: 'Cancelled', value: STATUS_CANCELLED },
  { label: 'Refunded', value: STATUS_REFUNDED },
  { label: 'Partially Refunded', value: STATUS_PARTIALLY_REFUNDED },
  { label: 'Failed', value: STATUS_FAILED },
  { label: 'Expired', value: STATUS_EXPIRED },
  { label: 'Pending', value: STATUS_PENDING },
];
